// extracted by mini-css-extract-plugin
module.exports = {"title":"CouponModal_title__r2MVe"};